import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {constants} from './common/commonExport';
import logo from '../../../src/assets/images/KeolisLogo.png';
import { impersonateLoginSuccess, getImpersonateEmpName } from "../actions/index";
import LoginComp from '../components/login';

class ImpersonateLogin extends React.Component {
    constructor(props) {
        super(props);
        //this.Auth = new AuthService();
        this.state = { // setting default state
            username: '',
            password: '',
            logo:logo,
            submitted: false,
            impersonateUserId:''
        };
    }
    
    // setting values in state on typying
    handleChange(e) { // changing of username/passowrd
        const { name, value } = e.target;       
       this.setState({ [name]: value });        
    }

    handleSubmit(e){ // submit action on Login

        e.preventDefault();
        this.setState({ submitted: true });
        const { impersonateUserId } = this.state;  
        

        if (impersonateUserId) {
            this.props.onLogin('LoginProgress');

            var url = '/get_employee_name/'+ impersonateUserId
            this.props.onGetImpersonateEmpName(url, (res) => {
                if(res.success == false){
                    this.props.onLogin('LoginError', res.errMsg);
                } else {
                  
                    var user = {
                        authenticated:this.props.authDetails.authenticated,
                        role: constants.roles.EMPLOYEE_ROLE,
                        id_token: this.props.authDetails.id_token,
                        api_token:this.props.authDetails.api_token,
                        name:res[0].emp_full_name,
                        employeeID:impersonateUserId,
                        impersonateUserId:impersonateUserId,
                        activeMenus : this.props.authDetails.activeMenus,
                        isSystemAdmin:res.isSystemAdmin,
                        userId:this.props.userId
                        
                    }
                    
                    this.props.onLogin('LoginSuccess', user); // login success action
                    let componentPath =  constants.routes.defaultEmpRoute; // component for Employee
                    this.props.navigate(componentPath, { replace: true });      
                    
                    
                }
                
            })
        }
    }
    render() {           
            
        const { submitted,impersonateUserId } = this.state;
        return (
            <LoginComp handleSubmit={this.handleSubmit.bind(this)} submitted ={submitted} 
                handleChange ={this.handleChange.bind(this)} logo={this.state.logo} showImpersonateUser={this.props.currentPathName=='/admin'} impersonateUserId={impersonateUserId} 
            />
        )
    }
}

function mapStateToProps(state) {
        
    return {
        authDetails:state.authState,
        currentLocation: location,
        
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            onLogin:impersonateLoginSuccess,
            onGetImpersonateEmpName: getImpersonateEmpName
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(ImpersonateLogin);
